import React from 'react';
import { Icon } from '../Icon';
export var MenuItemIcon = function (_a) {
    var size = _a.size, color = _a.color, name = _a.name;
    return (React.createElement(Icon, { size: size, color: color, name: name, style: { marginRight: 16 } }));
};
